import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetyDpiService {
    static tipi = (id_azienda = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/tipi`;
            const payload = {};
            if (id_azienda) payload.id_azienda = id_azienda;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static matriceByAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/matriceByAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static saveMatrice = (id_azienda, id_mansione, id_tipi) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/saveMatrice`;
            ApiService.postRequest(resolve, reject, url, {
                id_azienda,
                id_mansione,
                id_tipi,
            });
        });
    };

    static consegneByAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/consegneByAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static stats = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/stats`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static createConsegna = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/createConsegna`;
        return ApiService.postFormData(url, formData);
    };

    static deleteConsegna = (id_consegna) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/deleteConsegna`;
            ApiService.postRequest(resolve, reject, url, { id_consegna });
        });
    };

    static download = (id_consegna, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/dpi/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_consegna, filename });
        });
    };
}
